import React from 'react';
import { formatAffairAmount, formatAffairDate } from '../../affairs/affairFormatters';
import { getPartnerMetrics } from '../partnerMetrics';

const Metric = ({ label, value, description }) => <article className="partner-metric-card"><span>{label}</span><strong>{value}</strong><p>{description}</p></article>;

export default function PartnerMetricsPanel({ overview }) {
  const metrics = getPartnerMetrics(overview);
  return <section className="partner-section"><div className="partner-metrics-grid">
    <Metric label="Affaires en cours" value={metrics.openAffairCount} description={`${metrics.affairCount} affaire(s) au total.`} />
    <Metric label="Potentiel pondéré" value={formatAffairAmount(metrics.weightedPotentialAmount)} description={`Potentiel brut : ${formatAffairAmount(metrics.potentialAmount)}.`} />
    <Metric label="Projets actifs" value={metrics.activeProjectCount} description="Projets dont le statut n’est pas clôturé." />
    <Metric label="Devis en attente" value={metrics.pendingQuoteCount} description="Devis en revue interne ou envoyés." />
    <Metric label="Montant contractualisé" value={formatAffairAmount(metrics.contractedAmount)} description="Montants gagnés ou vendus explicitement rattachés." />
    <Metric label="Dernière activité" value={metrics.lastActivityAt ? formatAffairDate(metrics.lastActivityAt) : 'Aucune'} description="Date la plus récente parmi les activités valides." />
  </div></section>;
}
